/**
 * Ryan O'Dowd
 * 2022-08-28
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      height: globalScale * 24,
      justifyContent: 'center',
      alignSelf: 'center',
      backgroundColor: colors.primaryExtraDark,
      borderRadius: globalScale * 12,
      borderWidth: globalScale * 1,
      borderColor: colors.accentLight,
      margin: globalScale * 2,
      padding: globalScale * 4,
      paddingLeft: globalScale * 8,
      paddingRight: globalScale * 8,
    },
    leftTagIcon: {
      color: colors.accentLight,
      fontSize: globalScale * 16,
      alignSelf: 'center',
      marginRight: globalScale * 4,
    },
    tagText: {
      fontSize: globalScale * 12,
      color: colors.accentLight,
      alignSelf: 'center',
    },
    rightTagIcon: {
      color: colors.accentLight,
      fontSize: globalScale * 12,
      alignSelf: 'center',
      marginLeft: globalScale * 4,
    },
  };
};

export default getStyles;
